import template from './../../modules/main/templates/modals/serverErrorNotification.tmpl.html';

export default function TimeoutInterceptorWrapper($httpProvider) {
    'ngInject';
    $httpProvider.interceptors.push(TimeoutInterceptor);
}

export function TimeoutInterceptor($q, $injector) {
    'ngInject';
    const STATUS_CANCELLED = -1;

    return {
        responseError: function(response) {
            if (response.status === STATUS_CANCELLED) {
                const $uibModal = $injector.get('$uibModal');
                $uibModal.open({
                    template,
                    size: 'md',
                });
            }

            return $q.reject(response);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/configs/interceptors/timeout-interceptor.js